export const UPDATE_CALL_STATUS_START = "UPDATE_CALL_STATUS_START";
export const UPDATE_CALL_STATUS_SUCCESS = "UPDATE_CALL_STATUS_SUCCESS";
export const UPDATE_CALL_STATUS_FAILURE = "UPDATE_CALL_STATUS_FAILURE";

export const MARK_CALL_RECEIVED_START = "MARK_CALL_RECEIVED_START";
export const MARK_CALL_RECEIVED_SUCCESS = "MARK_CALL_RECEIVED_SUCCESS";
export const MARK_CALL_RECEIVED_FAILURE = "MARK_CALL_RECEIVED_FAILURE";
